import React from "react";

import { getAllSwimmingDifficultyCategory } from "../../../../redux/actions";
import { getSwimmingDifficultyCategory } from "../../../../redux/directoryMaintenance/swimmingDifficultyCategoryReducer/actionsSwimmingDifficultyCategory";

import GeneralSectionComponent from "../generalSectionComponent";
import SwimmingDifficultyCategoryModal from "./swimmingDifficultyCategoryModal/swimmingDifficultyCategoryModal";

import { SWIMMING_DIFFICULTY_CATEGORY } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

const SwimmingDifficultyCategory = () => {
  return (
    <GeneralSectionComponent
      title="Категория сложности района плавания"
      dataFromStateSelector={(state) =>
        state.dictionaryReducer.allSwimmingDifficultyCategory
      }
      getActionAll={getAllSwimmingDifficultyCategory}
      getAction={getSwimmingDifficultyCategory}
      headerColumns={SWIMMING_DIFFICULTY_CATEGORY}
      ModalComponent={SwimmingDifficultyCategoryModal}
    />
  );
};

export default SwimmingDifficultyCategory;
